"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateIteratee = generateIteratee;
exports.rewriteFramesIntegration = void 0;

var _integration = require("../integration.js");

var _path = require("../utils-hoist/path.js");

var _worldwide = require("../utils-hoist/worldwide.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const INTEGRATION_NAME = 'RewriteFrames';
/**
 * Rewrite event frames paths.
 */

const rewriteFramesIntegration = exports.rewriteFramesIntegration = (0, _integration.defineIntegration)((options = {}) => {
  const root = options.root;
  const prefix = options.prefix || 'app:///';
  const isBrowser = 'window' in _worldwide.GLOBAL_OBJ && _worldwide.GLOBAL_OBJ.window !== undefined;
  const iteratee = options.iteratee || generateIteratee({
    isBrowser,
    root,
    prefix
  });
  /** Process an exception event. */

  function _processExceptionsEvent(event) {
    try {
      return _objectSpread(_objectSpread({}, event), {}, {
        exception: _objectSpread(_objectSpread({}, event.exception), {}, {
          // The check for this is performed inside `process` call itself, safe to skip here
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          values: event.exception.values.map(value => _objectSpread(_objectSpread({}, value), value.stacktrace && {
            stacktrace: _processStacktrace(value.stacktrace)
          }))
        })
      });
    } catch (_oO) {
      return event;
    }
  }
  /** Process a stack trace. */


  function _processStacktrace(stacktrace) {
    return _objectSpread(_objectSpread({}, stacktrace), {}, {
      frames: stacktrace && stacktrace.frames && stacktrace.frames.map(f => iteratee(f))
    });
  }

  return {
    name: INTEGRATION_NAME,

    processEvent(originalEvent) {
      let processedEvent = originalEvent;

      if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
        processedEvent = _processExceptionsEvent(processedEvent);
      }

      return processedEvent;
    }

  };
});
/**
 * Exported only for tests.
 */

function generateIteratee({
  isBrowser,
  root,
  prefix
}) {
  return frame => {
    if (!frame.filename) {
      return frame;
    } // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`


    const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || frame.filename.includes('\\') && !frame.filename.includes('/'); // Check if the frame filename begins with `/`

    const startsWithSlash = /^\//.test(frame.filename);

    if (isBrowser) {
      if (root) {
        const oldFilename = frame.filename;

        if (oldFilename.indexOf(root) === 0) {
          frame.filename = oldFilename.replace(root, prefix);
        }
      }
    } else {
      if (isWindowsFrame || startsWithSlash) {
        const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
        .replace(/\\/g, '/') // replace all `\\` instances with `/`
        : frame.filename;
        const base = root ? (0, _path.relative)(root, filename) : (0, _path.basename)(filename);
        frame.filename = `${prefix}${base}`;
      }
    }

    return frame;
  };
}